'use strict';
module.exports = ([function () {
        return function (fileName) {
            var fileExtension = "";
            if (fileName) {
                var fileExtension = fileName.split('.').pop();
            }
            return fileExtension;
        };
    }]);





//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/filters/fileExtensionFilter.js
// module id = 281
// module chunks = 0